import styled from "styled-components";

const Styles = styled.div`
  /* 이벤트 관리 - 테이블 - new row */
  .row-new td {
    background: #feefef !important;
  }

  /* 이벤트 상황 조회 (팝업) */
  .event-info {
    font-size: 16px;
    margin-bottom: 12px;
  }

  /* 디바이스 상태 관리 - 테이블 - 통신상태 : 오류/정상*/
  .status-error,
  .status-normal {
    &::before {
      content: "";
      width: 11px;
      height: 11px;
      border-radius: 50%;
      margin-right: 8px;
      display: inline-block;
    }
  }
  .status-error::before {
    background: #ef5d5d;
  }
  .status-normal::before {
    background: #1a65bc;
  }

  & .tree-noexpand {
    & .ant-tree-switcher {
      display: none;
    }
  }
`;

export default Styles;
